import apiClient from './client';
import { ApiResponse, Client, PaginatedResponse, PaginationParams } from '@/types';

export const clientsApi = {
  getAll: (params?: PaginationParams) =>
    apiClient.get<PaginatedResponse<Client>>('/clients', { params }),

  getById: (id: string) =>
    apiClient.get<ApiResponse<Client>>(`/clients/${id}`),

  create: (data: Partial<Client>) =>
    apiClient.post<ApiResponse<Client>>('/clients', data),

  update: (id: string, data: Partial<Client>) =>
    apiClient.put<ApiResponse<Client>>(`/clients/${id}`, data),

  remove: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/clients/${id}`),
};
